import { render, staticRenderFns } from "./budget.vue?vue&type=template&id=217f7206&scoped=true&"
import script from "./budget.vue?vue&type=script&lang=js&"
export * from "./budget.vue?vue&type=script&lang=js&"
import style0 from "./budget.vue?vue&type=style&index=0&id=217f7206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217f7206",
  null
  
)

export default component.exports